import { takeEvery, put } from 'redux-saga/effects'
import { saveProfile, getIdentityProgress, updateNotificationsTime } from '../actions'

export function* handleUpdateProfileNotificationTime({ payload }) {
  yield put(saveProfile(payload))
  yield put(getIdentityProgress())
}

export default function* updateProfileSuccessTakeEvery() {
  yield takeEvery(updateNotificationsTime.toString(), handleUpdateProfileNotificationTime)
}
